
import { Link } from 'react-router-dom';
import { callout } from '../../../style/article';

export default function CertificationCallout({
  certificationCategory,
  projectName,
}: {
  certificationCategory?: string;
  projectName?: string;
}) {
  if (!certificationCategory || !projectName) {
    return null;
  }

  const categoryBlurb = () => {
    switch (certificationCategory) {
      case 'Certified offsets':
        return 'is classified as a <i>Certified offsets</i> project that represents quantified carbon offsets that have already occurred';
      case 'In-progress offsets':
        return 'is classified as an <i>In-progress offsets</i> project that takes longer to see results but is key in helping to solve the climate crisis';
      case 'Additional contributions':
        return 'is classified as an <i>Additional contributions</i> project that is not easily quantifiable in terms of carbon offsets, but supports systems-change needed for a sustainable future';
      case 'Investments':
        return 'is classified as an <i>Investments</i> project where Wren takes a hands-on role in project initiatives, and carbon impacts are assessed as part of the cost-benefit analysis';
    }
  };

  return (
    <div css={callout}>
      <p>
        Wren conducts due diligence using a scorecard comprised of 250+
        indicators and leverages insights from third-party carbon crediting
        agencies and experts.
      </p>
      <p>
        <i>{projectName}</i>{' '}
        <span dangerouslySetInnerHTML={{ __html: categoryBlurb() || '' }} />.
      </p>
      <p>
        <Link to="/certification">The layers of climate impact →</Link>
      </p>
    </div>
  );
}
